import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_70, COLOR_GRAY_90, COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  boxFeatures: {
    background: '#fff',
    padding: theme.spacing(6, 0, 9, 0),
  },
  tagPage: {
    color: COLOR_GRAY_70,
    fontSize: 18,
    fontWeight: 700,
    textAlign: 'center',
    display: 'block',
    fontFamily: 'Lato',
  },
  titleHero: {
    fontFamily: 'Lato',
    fontSize: 30,
    textAlign: 'center',
    color: COLOR_GRAY_70,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    lineHeight: 'inherit',
    '& b': {
      color: COLOR_PURPLE,
    },
  },
  titleHeroBlack: {
    fontFamily: 'Lato',
    fontSize: 30,
    textAlign: 'center',
    color: '#000',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(6),
    lineHeight: 'inherit',
    '& b': {
      color: COLOR_PURPLE,
    },
  },
  subtitle: {
    color: COLOR_GRAY_70,
    fontFamily: 'Lato',
    fontSize: 20,
    textAlign: 'center',
    maxWidth: '800px',
    margin: '0 auto',
  },

  titleCard: {
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(1),
    color: COLOR_GRAY_90,
    fontSize: 20,
    fontWeight: 700,
    fontFamily: 'Lato',
  },

  describeCard: {
    color: COLOR_GRAY_70,
    fontSize: 16,
    fontFamily: 'Lato',
    lineHeight: '32px',
  },
}));
